import { Pipe, PipeTransform } from '@angular/core';
import { Category } from '@hub-services/category';

@Pipe({
  name: 'getCategoryNames'
})
export class GetCategoryNamesPipe implements PipeTransform {

  transform(categoryIds: string[], categories: Category[]): any[] {
    return categories ? categoryIds.map((id) => categories.find(category => category.id === id)?.name ?? 'No category') : categoryIds;
  }
}
